import { getCO2AequivalentSubscope1, getCO2AequivalentSubscope49, getCO2AequivalentSubscope2, getCO2AequivalentSubscope5 } from '../../../main/functions/getCO2Aequivalent';
import { getCO2Scope3StructureAllgemein, getCO2Scope3StructureNachgelagert, getCO2Scope3StructureVorgelagert } from '../../../bereiche/dateneingabe/functions/getCO2Scope3Structure';
import { IDs } from '../../../helpers/IDs';
import * as React from 'react';

export function getAdditionalInfo(entity: string, field: string, values?: any, gefuehrt?: boolean): JSX.Element {

    // WICHTIG
    // Aktuell ist das nur für WFormFieldNumber implementiert.
    // Sobald bei anderen Feldern auch Hinweise benötigt werden, sind diese dort zu ergänzen
    values = values || {};

    switch (entity) {
        case IDs.ENT_CO2_SCOPE3_ABFALL:
            // if (field === 'kategorie') {
            //     const kategorie: string = values.kategorie;
            //     if (kategorie === 'kunststoff' || kategorie === 'metall') {
            //         return (
            //             <span>
            //                 Derzeit konnten noch keine plausiblen Emissionsfaktoren für die Kategorien "Kunststoff-" bzw. "Metallabfälle"
            //                 identifiziert werden; es ist daher aktuell noch nicht möglich, diese zu erfassen. Sofern Ihnen entsprechende
            //                 Faktoren bekannt sind, können Sie die Abfallfraktionen im Bereich "Weitere Emissionsquellen" (unten) erfassen.
            //                 Informieren Sie uns dann gerne unter <a href="mailto:service@energie-tool.de">service@energie-tool.de</a>&nbsp;
            //                 zu den von Ihnen gefundenen Faktoren.
            //             </span>
            //         );
            //     }
            // }
            break;
        case IDs.ENT_CO2_SCOPE3_EMITTENTEN:                // no break
        case IDs.ENT_CO2_SCOPE3_PRODUKTE_LEBENSZYKLUS:     // no break
        case IDs.ENT_CO2_SCOPE3_PRODUKTE_NUTZUNG:          // no break
        case IDs.ENT_CO2_SCOPE3_PRODUKTE_VERARBEITUNG:     // no break
        case IDs.ENT_CO2_SCOPE3_INVESTITION:               // no break
        case IDs.ENT_CO2_SCOPE3_ANGEMIETETE_SACHANLAGEN:   // no break
        case IDs.ENT_CO2_SCOPE3_VERMIETETE_SACHANLAGEN:    // no break
        case IDs.ENT_CO2_SCOPE3_FRANCHISE:                 // no break
        case IDs.ENT_CO2_SCOPE3_GUETER_KAPITAL:
            // if (field === 'faktor' && false /* Deaktiviert, da nicht mehr aktuell relevant */) {
            //     const bereich: string = getBereich(entity);
            //     return (
            //         <span>
            //             In {bereich ? `"${bereich}"` : 'diesem Bereich'} gibt es keine fest hinterlegten Emissionsfaktoren. Damit später die
            //             Gesamtemissionen Ihres Unternehmens korrekt berechnet werden, muss für jeden hier erfassten Emittenten selbst ein
            //             Emissionsfaktor hinterlegt werden. Diesen müssen Sie aus den gängigen Datenbanken entnehmen oder ggf. über ihre
            //             Zulieferer selbst in Erfahrung bringen. Bitte achten Sie dabei unbedingt darauf, dass die Einheit, in der Sie den
            //             Emittenten erfassen, mit der Einheit des aus der Datenbank herausgesuchten Emissionsfaktors zusammenpasst (z.B.
            //             Einheit Emittent: kWh → Einheit Emissionsfaktor: kg CO₂ / kWh). Mögliche Datenbanken (z.B.):<br />
            //             - <a href="https://iinas.org/downloads/gemis-downloads/" target="_blank">Gemis</a><br />
            //             - <a href="https://www.probas.umweltbundesamt.de/php/index.php" target="_blank">Probas</a><br />
            //             - <a href="https://www.gov.uk/government/collections/government-conversion-factors-for-company-reporting" target="_blank">DEFR</a><br />
            //             - <a href="https://ecoinvent.org/" target="_blank">Ecoinvent</a>
            //         </span>
            //     );
            // }
            break;
        case IDs.ENT_CO2_SCOPE3_GUETER_EINKAUF:
            if (field === 'art_tid' && values.art_tid === -2) {
                return (
                    <span>
                        Eine standardisierte Erfassung für Dienstleistungen wurde (noch) nicht im E-Tool integriert. Bitte nutzen Sie hierfür
                        die Kategorie "Weitere Emissionsquellen" am Ende {gefuehrt ? 'der Navigationsleiste' : 'dieser Seite'}.
                    </span>
                );
            }
            break;
        case IDs.ENT_CO2_SCOPE3_REISEN:
            if (field === 'firmenfahrzeug') {
                return (
                    <span>
                        Wenn die Dienstreise mit einem Firmenfahrzeug stattgefunden hat, werden die Emissionen des Transportfahrzeugs
                        bereits über die Sektion "Kraftstoffe" (Energiedaten) erfasst und bleiben hier unberücksichtigt. Erfassen Sie solche
                        Dienstreisen bitte nur dann, wenn auch Übernachtungen stattgefunden haben!
                    </span>
                );
            }
            if (!gefuehrt && field === 'hin_rueck') {
                return +(values.hin_rueck_orig || values.hin_rueck) === 1 ?
                    <span>
                        Bitte geben Sie im Feld Entfernung [km] nur den einfachen Weg an!
                    </span> :
                    <span>
                        Bitte geben Sie alle Teilstrecken von Hinfahrt- und Rückfahrt über den Teilstrecken-Rechner ein!
                    </span>;
            }
            break;
        case IDs.ENT_CO2_SCOPE3_PENDELN: // no break
        case IDs.ENT_CO2_SCOPE3_TRANSPORT_VORGELAGERT: // no break
        case IDs.ENT_CO2_SCOPE3_TRANSPORT_NACHGELAGERT:
            if (!gefuehrt && field === 'hin_rueck') {
                return +(values.hin_rueck_orig || values.hin_rueck) === 1 ?
                    <span>
                        Bitte geben Sie den einfachen Weg an!
                    </span> :
                    <span>
                        Bitte geben Sie alle Teilstrecken von Hinfahrt- und Rückfahrt über den Teilstrecken-Rechner ein!
                    </span>;
            }
            break;
        default:
            return null;
    }
}

export function getBereich(entity: string): string {
    const subscopes: Array<any> = [
        ...getCO2Scope3StructureVorgelagert() || [],
        ...getCO2Scope3StructureNachgelagert() || [],
        ...getCO2Scope3StructureAllgemein() || []
    ];
    const key: string = entity.replace('co2_scope3_', '');
    return (subscopes.find((item: any) => item.key === key) || {}).name || null;
}

export function getAdditionalIconInfo(entity: string, field: string, values: any, data: any, gefuehrt?: boolean): JSX.Element {

    // faktor_wert = faktor.wert;
    // faktor_name = faktor.name;
    // console.log('getAdditionalIconInfo', values);

    switch (entity) {
        case IDs.ENT_CO2_SCOPE3_EMITTENTEN:
        case IDs.ENT_CO2_SCOPE3_PRODUKTE_LEBENSZYKLUS:
        case IDs.ENT_CO2_SCOPE3_PRODUKTE_NUTZUNG:
        case IDs.ENT_CO2_SCOPE3_PRODUKTE_VERARBEITUNG:
        case IDs.ENT_CO2_SCOPE3_INVESTITION:
        case IDs.ENT_CO2_SCOPE3_ANGEMIETETE_SACHANLAGEN:
        case IDs.ENT_CO2_SCOPE3_VERMIETETE_SACHANLAGEN:
        case IDs.ENT_CO2_SCOPE3_FRANCHISE:
        case IDs.ENT_CO2_SCOPE3_GUETER_KAPITAL:
        case IDs.ENT_CO2_SCOPE3_GUETER_EINKAUF:
            const einheit = +values.modus > 0 ? values.einheit : 't';
            let arr_mat = [];
            if (entity === IDs.ENT_CO2_SCOPE3_GUETER_EINKAUF) {
                arr_mat = data[IDs.ENT_CO2_SCOPE3_FAKTOREN_MATERIAL];
            } else {
                arr_mat = data[IDs.ENT_CO2_SCOPE3_FAKTOREN_GUETER];
            }
            const mat = arr_mat.find((m: any) => (values.art_tid_orig || values.art_tid) === m.tid);
            if (!mat) {
                return <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>Es wurde kein Art gewählt.</div>
                </div>;
            }
            let faktor = null;
            if (entity === IDs.ENT_CO2_SCOPE3_GUETER_EINKAUF) {
                faktor = getCO2AequivalentSubscope1(data, values.jahr, mat.name, einheit);
            } else {
                faktor = getCO2AequivalentSubscope2(data, values.jahr, mat.name, einheit);
            }
            return <div style={{ padding: 20, fontSize: 16, display: 'flex', flexDirection: 'column' }}>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ width: 150 }}> Material: </div>
                    <div><b>{faktor.name}</b></div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ width: 150 }}> Faktor: </div>
                    <div>{faktor.wert} t CO2 Äq / {einheit}</div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ width: 150 }}> Jahr: </div>
                    <div> {values.jahr} </div>
                </div>
            </div>;
        case IDs.ENT_CO2_SCOPE3_ABFALL:
            const faktor_abfall = getCO2AequivalentSubscope5(data, values.jahr, values);
            return <div style={{ padding: 20, fontSize: 16, display: 'flex', flexDirection: 'column' }}>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ width: 150 }}> Kategorie: </div>
                    <div><b>{faktor_abfall.name}</b></div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ width: 150 }}> Faktor: </div>
                    <div>{faktor_abfall.wert} t CO2 Äq / km</div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ width: 150 }}> Jahr: </div>
                    <div> {values.jahr} </div>
                </div>
            </div>;
        case IDs.ENT_CO2_SCOPE3_TRANSPORT_VORGELAGERT:
        case IDs.ENT_CO2_SCOPE3_TRANSPORT_NACHGELAGERT:
            const faktor_transport = getCO2AequivalentSubscope49(data, values.jahr, values.transportmittel, entity, 'transportmittel');
            return <div style={{ padding: 20, fontSize: 16, display: 'flex', flexDirection: 'column' }}>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ width: 150 }}> Transportmittel: </div>
                    <div><b>{faktor_transport.info}</b></div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ width: 150 }}> Faktor: </div>
                    <div>{faktor_transport.wert} t CO2 Äq / km</div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ width: 150 }}> Jahr: </div>
                    <div> {values.jahr} </div>
                </div>
            </div>;
        case IDs.ENT_CO2_SCOPE3_REISEN:
        default:
            return <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div style={{ display: 'flex', flexDirection: 'row' }}>Noch nicht implementiert!</div>
            </div>;
    }
}
